/* global jQuery COMPONENTS */

COMPONENTS.ComponentNearbyProperties = (function ($) {
  function ComponentNearbyProperties () {
    this.utility = new COMPONENTS.Utility()
    this.$propertiesComponents = $('[data-ecs-component="component-nearbyproperties"]')
  }

  ComponentNearbyProperties.prototype.init = function () {
    const component = this

    component.$propertiesComponents.each(function () {
      const $component = $(this)
      const utility = new COMPONENTS.Utility()
      $component.index = $component.data('ecs-content-index')
      $component.template = $component.attr('data-ecs-template')
      $component.$propertiesSlider = $component.find('[data-ecs-component-control="nearbyproperties-slider"]')

      $component.sliderVars = {
        propertiesSlider: utility.getSliderVars(3, false)
      }

      $component.$propertiesSlider.slick($component.sliderVars.propertiesSlider)
      utility.bindSliderAriaSelected($component.$propertiesSlider)
    })
  }

  return ComponentNearbyProperties
})(jQuery)

document.addEventListener('components_init', function (e) {
  // Hook into the main components init
  COMPONENTS.ComponentNearbyProperties = new COMPONENTS.ComponentNearbyProperties()
  COMPONENTS.ComponentNearbyProperties.init()
})
